import {
  QUIZ_SUBPATH,
  INTRO_SLUG,
  PUP_NAME_SLUG,
  PUP_GENDER_SLUG,
  PUP_STATUS_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  ALLERGY_SELECTION_SLUG,
  USER_INFO_SLUG,
  RECOMMENDED_PLAN_SUBPATH,
  ADDONS_SELECTION_SUBPATH,
  CHECKOUT_SUBPATH,
  DELETE_PET_SUBPATH,
} from '../routing';

export const ALL_RECIPES = ['chicken', 'beef', 'lamb', 'turkey', 'pork'];

export const PRODUCT_TYPES = {
  fresh: 'fresh',
  dry: 'dry',
  mixed: 'mixed',
  half_fresh: 'half_fresh',
};

export const ROOT_SUBPATH = '/onboarding-v2/';

export const STATE = {
  initial: ROOT_SUBPATH,
  intro: `${INTRO_SLUG}`,
  pupName: `${QUIZ_SUBPATH}/${PUP_NAME_SLUG}`,
  pupGender: `${QUIZ_SUBPATH}/${PUP_GENDER_SLUG}`,
  pupStatus: `${QUIZ_SUBPATH}/${PUP_STATUS_SLUG}`,
  weight: `${QUIZ_SUBPATH}/${CALORIES_SLUG}`,
  activity: `${QUIZ_SUBPATH}/${ACTIVITY_SLUG}`,
  allergies: `${QUIZ_SUBPATH}/${ALLERGIES_SLUG}`,
  allergySelection: `${QUIZ_SUBPATH}/${ALLERGY_SELECTION_SLUG}`,
  recommendedPlan: RECOMMENDED_PLAN_SUBPATH,
  submitCart: 'submit',
  extras: ADDONS_SELECTION_SUBPATH,
  userInfo: USER_INFO_SLUG,
  checkout: CHECKOUT_SUBPATH,
  deletePet: DELETE_PET_SUBPATH,
};

export const ACTION_TYPES = {
  initialLoad: 'initialLoad',
  toIntro: 'toIntro',
  toPupName: 'toPupName',
  toPupGender: 'toPupGender',
  toPupStatus: 'toPupStatus',
  toWeight: 'toWeight',
  toActivity: 'toActivity',
  toAllergies: 'toAllergies',
  toAllergySelection: 'toAllergySelection',
  toRecommendedPlan: 'toRecommendedPlan',
  toExtras: 'toExtras',
  toCheckout: 'toCheckout',
  toUserInfo: 'toUserInfo',
  customerInfoSaved: 'customerInfoSaved',
  selectedFreshRecipes: 'selectedFreshRecipes',
  selectedMixedRecipes: 'selectedMixedRecipes',
  goBack: 'goBack',
  deletePet: 'deletePet',
};

export const ACTIONS = {
  initialLoad: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.initialLoad,
  }),
  toIntro: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toIntro,
  }),
  toPupName: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupName,
  }),
  toPupGender: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupGender,
  }),
  toPupStatus: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupStatus,
  }),
  toWeight: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toWeight,
  }),
  toActivity: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toActivity,
  }),
  toAllergies: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAllergies,
  }),
  toAllergySelection: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAllergySelection,
  }),
  customerInfoSaved: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.customerInfoSaved,
  }),
  toRecommendedPlan: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toRecommendedPlan,
    };
  },
  toExtras: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toExtras,
  }),
  toUserInfo: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toUserInfo,
  }),
  toCheckout: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toCheckout,
  }),
  selectedFreshRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedFreshRecipes,
      props,
    };
  },
  selectedMixedRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedMixedRecipes,
      props,
    };
  },
  goBack: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.goBack,
    };
  },
  deletePet: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.deletePet,
  }),
};

export const pathToAction = {
  [STATE.intro]: ACTIONS.toIntro,
  [STATE.pupName]: ACTIONS.toPupName,
  [STATE.pupGender]: ACTIONS.toPupGender,
  [STATE.pupStatus]: ACTIONS.toPupStatus,
  [STATE.weight]: ACTIONS.toWeight,
  [STATE.activity]: ACTIONS.toActivity,
  [STATE.allergies]: ACTIONS.toAllergies,
  [STATE.allergySelection]: ACTIONS.toAllergySelection,
  [STATE.recommendedPlan]: ACTIONS.toRecommendedPlan,
  [STATE.extras]: ACTIONS.toExtras,
  [STATE.userInfo]: ACTIONS.toUserInfo,
  [STATE.checkout]: ACTIONS.toCheckout,
};

export const STATE_TO_STEP_REFERENCE = {
  [STATE.recommendedPlan]: 0,
  [STATE.submitCart]: 1,
  [STATE.extras]: 1,
  [STATE.userInfo]: 2,
  [STATE.checkout]: 3,
};

export const unmappedStates = [STATE.initial, STATE.submitCart];

// Shopify TODO: We can and should delete this post-Shopify MVP, this simplifies migration for now
export const BC_TO_SHOPIFY_SKU_MAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'JERKYSTRIPS-BE': 'TRT-JERKYSTRIPS-BSP',
  /* Chicken and Apple Jerky Strips */
  'JERKYSTRIPS-CH': 'TRT-JERKYSTRIPS-CA',
  /* Salmon and Coconut Jerky Strips */
  'JERKYSTRIPS-SA': 'TRT-JERKYSTRIPS-SC',
  /* Peanut Butter Frozen Treat */
  'FR-ICECREAM-PBB': 'TRT-FROZENTREAT-PB',
  /* Crunchy Treats with Sweet Potato */
  'TREAT-SWEETPOTATOCRNCH-08': 'TRT-CRUNCHY-SP',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TREAT-APPLECRNCH-08': 'TRT-CRUNCHY-AMB',
  /* Training Treats with Parmesan */
  'TREAT-PARMTRAINING-08': '',
  /* Training Treats with Peanut Butter */
  'TREAT-PBTRAINING-08': '',
  /* Skin & Coat Chews */
  'SUPP-SKIN': 'SPPL-SKINCOAT',
  /* Probiotic Chews */
  BELLYRUBS01: 'SPPL-PROBIOTIC',
  /* Hip & Joint Chews */
  ZOOMIES01: 'SPPL-HIPJOINT',
  /* Calming Chews */
  CHILLPILLS01: 'SPPL-CALMING',
  /* Dental Chews */
  'SUPP-DENT-XS': 'DC-DENTALCHEWS-XS',
  'SUPP-DENT-SM': 'DC-DENTALCHEWS-SM',
  'SUPP-DENT-MD': 'DC-DENTALCHEWS-MD',
  'SUPP-DENT-LG': 'DC-DENTALCHEWS-LG',
};

// Same as above, just reversed
export const SHOPIFY_TO_BC_SKU_SMAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'TRT-JERKYSTRIPS-BSP': 'JERKYSTRIPS-BE',
  /* Chicken and Apple Jerky Strips */
  'TRT-JERKYSTRIPS-CA': 'JERKYSTRIPS-CH',
  /* Salmon and Coconut Jerky Strips */
  'TRT-JERKYSTRIPS-SC': 'JERKYSTRIPS-SA',
  /* Peanut Butter Frozen Treat */
  'TRT-FROZENTREAT-PB': 'FR-ICECREAM-PBB',
  /* Crunchy Treats with Sweet Potato */
  'TRT-CRUNCHY-SP': 'TREAT-SWEETPOTATOCRNCH-08',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TRT-CRUNCHY-AMB': 'TREAT-APPLECRNCH-08',
  /* Training Treats with Parmesan */
  'TREAT-PARMTRAINING-08': 'TREAT-PARMTRAINING-08',
  /* Training Treats with Peanut Butter */
  'TREAT-PBTRAINING-08': 'TREAT-PBTRAINING-08',
  /* Skin & Coat Chews */
  'SPPL-SKINCOAT': 'SUPP-SKIN',
  /* Probiotic Chews */
  'SPPL-PROBIOTIC': 'BELLYRUBS01',
  /* Hip & Joint Chews */
  'SPPL-HIPJOINT': 'ZOOMIES01',
  /* Calming Chews */
  'SPPL-CALMING': 'CHILLPILLS01',
  /* Dental Chews */
  'DC-DENTALCHEWS-XS': 'SUPP-DENT-XS',
  'DC-DENTALCHEWS-SM': 'SUPP-DENT-SM',
  'DC-DENTALCHEWS-MD': 'SUPP-DENT-MD',
  'DC-DENTALCHEWS-LG': 'SUPP-DENT-LG',
};

export const levelToLabel = {
  Low: 'mellow',
  Moderate: 'active',
  High: 'very active',
};
